import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import Thread from '../Thread/Thread';

/**
 * Message Board = the admin team ↔ client live chat for a workspace.
 * Works on both sides — the outlet context supplies clientId + isAdmin.
 */
export default function MessageBoard() {
  const { clientId, client, isAdmin } = useOutletContext();
  const clientFirstName = client?.name ? client.name.split(/\s+/)[0] : 'the client';
  const placeholder = isAdmin ? `Message ${clientFirstName}…` : 'Message the team…';

  return (
    <div className="message-board-page">
      <div className="message-board-header">
        <span className="message-board-icon"><MessageSquare size={18} /></span>
        <div>
          <span className="workspace-eyebrow">Shared conversation</span>
          <h2>Message board</h2>
          <p>
            {isAdmin
              ? `A live, shared conversation with ${client?.name || 'the client'}.`
              : 'Chat directly with the Evercrest project team.'}
          </p>
        </div>
      </div>
      <Thread threadType="board" threadId={clientId} height="min(70dvh, 680px)" placeholder={placeholder} />
    </div>
  );
}
